export default function DashboardSkeleton() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-12">
      <div className="h-6 dark:bg-dark-elevated bg-light-elevated w-48 mb-8 animate-pulse" />
      <div className="space-y-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="h-20 th-bg-surface border th-border animate-pulse" />
        ))}
      </div>
    </div>
  );
}
